import React from "react";
import HeaderLandingPage from "../_layout/elements/landing-header";

import bannerimage from "../landing_website/assets/images/bannerimage2.png";
import subscription from "../landing_website/assets/images/subscription.png";
import ProfessionalFile from "../landing_website/assets/images/ProfessionalFile.png";
import Smartchat from "../landing_website/assets/images/smartChat.png";
import powersearch from "../landing_website/assets/images/powersearch.png";
import Seamless from "../landing_website/assets/images/shemless.png";
import globallocal from "../landing_website/assets/images/globallocalsearch.png";
import { TextField } from "@mui/material";
import { motion } from "framer-motion";
import FooterLandingPage from "../_layout/elements/landing-footer";

export const LandingHome = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <HeaderLandingPage />
      <section className="banner" id="Home">
        <div className="container">
          <div className="row">
            <div className="banner-content-box">
              <div className="banner-content">
                <h1>
                  {" "}
                  Conversations <br /> beyond boundaries{" "}
                </h1>
                <p>Experience the power of Artificial Intelligence. Effortlessly chat and interact with any document.</p>
                <div className="banner_mail">
                  <div className="   search_library_inputbox">
                    <TextField id="outlined-multiline-flexible" placeholder="Enter Your Email" />
                    <div className="banner_button">
                      <button type="button" className="btn btn-primary ">
                        {" "}
                        Get Started
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="banner-image">
                <img src={bannerimage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="padding_medium" id="Features">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.5 }} className="step-heading">
                <h2 className="text-center mt-3"> Top Features and Benefits </h2>
                <p className="text-center   margbottom-50  paddinglr ">
                  NGPT is here to solve all your needs. And it achieves this by incorporating various solution drivers which plug and play this amazing tool forward.
                </p>
              </motion.div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="our_features_list">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6 }} className="our_features_box  ">
                  <div className="our_features_flex textleft_imagetight">
                    <div className="feature_content">
                      <div className="feature_title">
                        <h2>Global-Local Search Options</h2>
                        <p>Users can choose to search within their uploaded files or toggle browser search for worldwide web results. You can even do both simultaneously for comprehensive results.</p>
                      </div>
                    </div>
                    <div className="feature_image">
                      <div className="feature_image_box">
                        <img src={globallocal} alt="Global-Local Search Options" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="our_features_list">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6 }} className="our_features_box  fourbox ">
                  <div className="our_features_flex textleft_imagetight">
                    <div className="feature_content">
                      <div className="feature_title">
                        <h2>Seamless Integration</h2>
                        <p>
                          Our tool seamlessly fits into your existing workflow. Whether working with PDFs, Excel sheets or Documents, you can effortlessly upload, search, and interact with your
                          documents.
                        </p>
                      </div>
                    </div>
                    <div className="feature_image">
                      <div className="feature_image_box">
                        <img src={Seamless} alt="Seamless Integration" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="our_features_list">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6 }} className="our_features_box fourbox ">
                  <div className="our_features_flex textleft_imagetight">
                    <div className="feature_content">
                      <div className="feature_title">
                        <h2>Powerful Search, Analysis, and Updates</h2>
                        <p>Eliminate endless scrolling. Perform in-depth text analysis, generate insights, and update your files all at once with our powerful search tool.</p>
                      </div>
                    </div>
                    <div className="feature_image">
                      <div className="feature_image_box">
                        <img src={powersearch} alt="Powerful Search, Analysis, and Updates" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="our_features_list">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6 }} className="our_features_box  fourbox ">
                  <div className="our_features_flex textleft_imagetight">
                    <div className="feature_content">
                      <div className="feature_title">
                        <h2>Smart Chat Functionality</h2>
                        <p>Converse with your documents and the internet at the same time. Whether seeking specific information or context, our smart chat feature supports your needs.</p>
                      </div>
                    </div>
                    <div className="feature_image">
                      <div className="feature_image_box">
                        <img src={Smartchat} alt="Smart Chat Functionality" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="our_features_list">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6 }} className="our_features_box fourbox ">
                  <div className="our_features_flex textleft_imagetight">
                    <div className="feature_content">
                      <div className="feature_title">
                        <h2>Professional File Management</h2>
                        <p>
                          Utilize our built-in file management system to store and work with various file types simultaneously. Enjoy dedicated management space with extensive sorting and uploading
                          filters.
                        </p>
                      </div>
                    </div>
                    <div className="feature_image">
                      <div className="feature_image_box">
                        <img src={ProfessionalFile} alt="Professional File Management" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="padding_medium howitwork">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-4">
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.5 }} className="step-heading">
                <h2 className=" mt-3">How It Works?</h2>
                <p className="   "> Our AI-driven chatbot simplifies file management and document interaction through intuitive natural language processing.</p>
              </motion.div>
            </div>
            <div className="col-md-8">
              <div className="row  ">
                <div className="col-md-6 colmargin">
                  <div className="how_it_work_box">
                    <div className="card">
                      <h3>Global Search</h3>
                      <p>Experience the power of safe internet search combined with our advanced search technology. Every search is linked to verifiable sources, ensuring reliable information.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 colmargin">
                  <div className="how_it_work_box">
                    <div className="card">
                      <h3>Local Search</h3>
                      <p>Search exclusively within your uploaded files for precise, file-specific results.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 colmargin">
                  <div className="how_it_work_box">
                    <div className="card">
                      <h3>Combined Search</h3>
                      <p>Our tool’s most powerful feature is the integration of global and local searches, providing users with unique and robust search capabilities.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 colmargin">
                  <div className="how_it_work_box">
                    <div className="card">
                      <h3>Simplistic UI</h3>
                      <p>Avoid complex screens and multiple buttons. Our clean, original UI design allows users to perform all actions within a single space, without leaving the page.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section_pedding subscribe">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-10">
              <div className="subscriptionbox">
                <div className="banner-content-box">
                  <div className="subscriptionbox-content">
                    <h2> Looking for something </h2>
                    <p> Subscribe to our newsletter</p>
                    <div className="banner_mail">
                      <div className="   search_library_inputbox">
                        <TextField id="outlined-multiline-flexible" placeholder="Enter Your Email" />
                        <div className="banner_button">
                          <button type="button" className="btn btn-primary ">
                            {" "}
                            Get Started
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="subscriptionbox-image  ">
                    <img src={subscription} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterLandingPage />
    </div>
  );
};
